<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p8"><span><a href="#/Contents#rp8">QUICK-SPICED BEEF STOCK</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>When you want a spicy stock, give this easy version a try.</i></span></p>
<p class="make"><span>Makes about 2 cups</span></p>
<p class="hang"><span>1 can (14 ounces) reduced-sodium fat-free beef broth</span></p>
<p class="hang"><span>1 medium onion, quartered</span></p>
<p class="hang"><span>1 clove garlic</span></p>
<p class="hang"><span>1 tablespoon dry red wine or water</span></p>
<p class="hang"><span>1 teaspoon pickling spice</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><a id="page_7"></a><b>1.</b> Heat all ingredients, except salt and pepper, to boiling in large saucepan; reduce heat and simmer, covered, 10 minutes. Strain; discard vegetables and seasonings. Season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Cup:</span></p>
<p class="per1"><span>Calories: 25</span></p>
<p class="per1"><span>% calories from fat: 0</span></p>
<p class="per1"><span>Protein (g): 4.3</span></p>
<p class="per1"><span>Carbohydrate (g): 0.9</span></p>
<p class="per1"><span>Fat (g): 0</span></p>
<p class="per1"><span>Saturated fat (g): 0</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 133</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter018.vue?5308d566